<template>
  <div id="header">
    <img src="../assets/image/top-logo.png" alt=""  />
    <div class="menuList">
      <div
        :class="active == item.path ? 'item' : ''"
        v-for="item in menuList"
        :key="item.path"
        @click="goPage(item.path)"
      >
        {{ item.name }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: "",
      menuList: [
        {
          name: "首页",
          path: "homePage",
        },
        {
          name: "品牌介绍",
          path: "introduce",
        },
        {
          name: "倾诉",
          path: "confide",
        },
        {
          name: "倾听者",
          path: "listener",
        },
      ],
    };
  },
  created() {
    this.active = this.$route.name;
  },
  watch: {
    $route(value) {
      this.active = value.name;
    },
  },
  methods: {
    goPage(name) {
      this.$router.push({name});
    },
  },
};
</script>

<style scoped>
#header {
  padding: 30px;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
#header img{
  width: 60px;
}
.menuList {
  width: 30%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  cursor: pointer;
}
.menuList .item {
  border-bottom: 3px solid #2abbb4;
  padding: 10px 0;
  font-weight: bold;
}
.btn {
  background: #2abbb4;
  border-radius: 20px;
  color: #fff;
  padding:10px 20px;
}

</style>
